module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[101]344.7a47d4a.woff2";